/**
 * @generated SignedSource<<914b57f1bd846f59dc012984cb94d947>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskModalHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticlesSearch_viewer">;
  readonly " $fragmentType": "GetHelpZendeskModalHeader_viewer";
};
export type GetHelpZendeskModalHeader_viewer$key = {
  readonly " $data"?: GetHelpZendeskModalHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskModalHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskModalHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskArticlesSearch_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f0aeddabad11245f7b988bd7214bedf6";

export default node;
